import { FC, HTMLAttributes, KeyboardEvent } from 'react';
import classNames from 'classnames';
import st from './RadioBtn.module.scss';

interface IRadioBtnProps extends HTMLAttributes<HTMLInputElement> {
	/** Наименование контрола */
	name: string;
	/** Значение */
	value: string | number;
	/** Заголовок кнопки */
	label: string;
	/** Не доступно */
	disabled?: boolean;
	/** Выбранное состояние */
	checked?: boolean;
	/** Флаг НЕ валидности поля - подсвечивает кнопку красным */
	isInvalid?: boolean;

	multiple?: boolean;
}

/** Радио-кнопка */
const RadioBtn: FC<IRadioBtnProps> = ({
	label,
	className,
	multiple,
	isInvalid = false,
	onKeyDown,
	...otherProps
}) => {
	const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			(e.target as HTMLInputElement).click();
		}
		onKeyDown?.(e);
	};

	return (
		<label
			className={classNames(st.wrapper, className, {
				[st.invalid]: isInvalid,
			})}
		>
			<input
				type={multiple ? 'checkbox' : 'radio'}
				className={st.input}
				onKeyDown={handleKeyDown}
				{...otherProps}
			/>
			<span className={st.label}>{label}</span>
		</label>
	);
};

export default RadioBtn;
